import { useQuery } from '@tanstack/react-query';
import type { PaginatedList } from '../../models/common/paginated-list.model';
import type { PaymentSchemesDto } from '../../models/payment-schemes/payment-schemes.dto';
import apiRequest from '../../services/apiWrapper';
import { createPaginatedQueryKeys } from '../../services/createPaginatedQueryKeys';
import { PAYMENT_SCHEMES_URL } from '../../utils/constants/urlConstants';

async function fetchPaymentSchemes(searchParams: URLSearchParams) {
  const response = await apiRequest.get<PaginatedList<PaymentSchemesDto>>(
    `${PAYMENT_SCHEMES_URL}?ordering=0&${searchParams.toString()}`
  );
  return response.data;
}

function createQueryKey(searchParams: URLSearchParams) {
  return {
    name: searchParams.get('name'),
    status: searchParams.get('status'),
    ...createPaginatedQueryKeys(searchParams),
  };
}

export function usePaginatedPaymentSchemes(searchParams: URLSearchParams) {
  return useQuery({
    queryKey: ['payment-schemes', createQueryKey(searchParams)],
    queryFn: () => fetchPaymentSchemes(searchParams),
  });
}
